import React, { useState } from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import PositionedModal from 'common/components/PositionedModal';

interface CopilotDisclaimerLinkProps {
  children: React.ReactNode;
  modalTitle?: string;
  modalContent?: React.ReactNode;
}

const DisclaimerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  color: #777;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  font-family: inherit;

  &:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const DisclaimerText = styled.div`
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  margin-bottom: 16px;
`;

const CopilotDisclaimerLink: React.FC<CopilotDisclaimerLinkProps> = ({
  children,
  modalTitle = 'AI Disclaimer',
  modalContent,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <DisclaimerButton onClick={() => setIsOpen(true)}>
        <IconWrapper>
          <Icon name="warning sign" size="small" color="yellow" />
        </IconWrapper>
        {children}
      </DisclaimerButton>

      <PositionedModal open={isOpen} onClose={() => setIsOpen(false)} size="small">
        <Modal.Header>{modalTitle}</Modal.Header>
        <Modal.Content>
          {modalContent ?? (
            <>
              <DisclaimerText>
                AI-generated responses are provided for informational purposes only and may contain
                inaccuracies, omissions, or outdated information. They do not constitute legal,
                medical, financial, professional, or ethical advice. You are solely responsible for
                independently verifying any information before relying on it or taking action.
              </DisclaimerText>
              <DisclaimerText>
                Use of this system to support illegal, harmful, fraudulent, or unethical activity is
                prohibited. By using this system, you acknowledge and agree to these terms. If you do not
                agree, please do not use nuLogic's AI functionality.
              </DisclaimerText>
            </>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setIsOpen(false)}>Close</Button>
        </Modal.Actions>
      </PositionedModal>
    </>
  );
};

export default CopilotDisclaimerLink;
